/**
 * Marathi for the two core namespaces (BP-19.T2).
 *
 * **Machine draft, not reviewed** — see `hi.ts` for why `settings` is absent and what
 * the `{{…}}` placeholders are for.
 */

export const mrCommon = {
  app: {
    staff: '26AD स्टाफ',
    client: '26AD',
  },
  nav: {
    label: 'सेटिंग्ज',
    tenant: 'सलून',
    users: 'वापरकर्ते',
    security: 'सुरक्षा',
    logout: 'लॉग आउट',
    signIn: 'साइन इन',
    more: 'अधिक',
    group: {
      frontDesk: 'फ्रंट डेस्क',
      salon: 'सलून',
      business: 'व्यवसाय',
    },
    item: {
      home: 'होम',
      calendar: 'दिनदर्शिका',
      myDay: 'माझा दिवस',
      sales: 'विक्री',
      clients: 'ग्राहक',
      dayClose: 'दिवस बंद',
      catalogue: 'कॅटलॉग',
      services: 'सेवा',
      stock: 'साठा',
      team: 'टीम',
      marketing: 'मार्केटिंग',
      reports: 'अहवाल',
      money: 'पैसे',
      settings: 'सेटिंग्ज',
      printQueue: 'प्रिंट रांग',
      myCommission: 'माझे कमिशन',
      commissions: 'कमिशन',
      myShifts: 'माझ्या शिफ्ट',
      accounting: 'लेखा',
    },
  },
  action: {
    save: 'जतन करा',
    saving: 'जतन करत आहे…',
    cancel: 'रद्द करा',
    retry: 'पुन्हा प्रयत्न करा',
  },
  state: {
    loading: 'लोड होत आहे…',
    empty: 'इथे अजून काही नाही.',
    error: 'काहीतरी चुकले.',
  },
  banner: {
    readonly:
      'हे वर्कस्पेस फक्त वाचण्यासाठी आहे. तुम्ही सर्व काही पाहू शकता; पुन्हा सुरू होईपर्यंत बदल स्वीकारले जाणार नाहीत.',
    offline: 'तुम्ही ऑफलाइन आहात. या डिव्हाइसवर साठवलेला शेवटचा डेटा दाखवत आहोत.',
  },
  route: {
    notFound: 'पेज सापडले नाही',
    forbidden: 'या पेजसाठी तुम्हाला परवानगी नाही.',
  },
  locale: {
    label: 'भाषा',
    switch: 'भाषा बदला',
    draft:
      'हिंदी, मराठी आणि गुजराती हे यंत्राने तयार केलेले मसुदे आहेत; सलूनने ते अजून तपासलेले नाहीत.',
  },
  hello: {
    title: '26AD नमस्कार',
    loading: '26AD api शी संपर्क साधत आहे…',
    error: '26AD api पर्यंत पोहोचता आले नाही.',
  },
} as const;

export const mrAuth = {
  login: {
    title: 'साइन इन',
    email: 'ईमेल',
    password: 'पासवर्ड',
    submit: 'साइन इन करा',
    submitting: 'साइन इन करत आहे…',
    redirecting: 'तुम्हाला साइन इन पानावर नेत आहोत…',
  },
  totp: {
    title: 'दोन-टप्पी पडताळणी',
    hint: 'तुमचे खाते ऑथेंटिकेटर अ‍ॅपने सुरक्षित आहे. सध्या दिसणारा सहा अंकी कोड टाका.',
    code: 'एकदाच वापरायचा कोड',
    submit: 'पडताळा',
  },
  otp: {
    title: 'साइन इन',
    phone: 'मोबाइल नंबर',
    phoneHint: 'आंतरराष्ट्रीय स्वरूपात, उदा. +919820000000',
    send: 'कोड पाठवा',
    sending: 'पाठवत आहे…',
    sent: 'आम्ही {{phone}} वर कोड पाठवला आहे.',
    code: 'सहा अंकी कोड',
    verify: 'पडताळा',
    verifying: 'पडताळत आहे…',
    devCode: 'डेव्हलपमेंट कोड: {{code}}',
    signedIn: '{{phone}} म्हणून साइन इन',
    role: 'भूमिका: ग्राहक',
  },
  error: {
    invalid: 'हा ईमेल, पासवर्ड किंवा एकदाच वापरायचा कोड बरोबर नाही.',
    locked: 'खूप वेळा प्रयत्न झाले. एक मिनिट थांबून पुन्हा प्रयत्न करा.',
    readonly: 'हे वर्कस्पेस फक्त वाचण्यासाठी आहे, त्यामुळे आता साइन इनने सत्र सुरू होऊ शकत नाही.',
    unknown: 'साइन इन होऊ शकले नाही. पुन्हा प्रयत्न करा.',
    phone: 'मोबाइल नंबर आंतरराष्ट्रीय स्वरूपात टाका, उदा. +919820000000.',
    otp: 'हा कोड बरोबर नाही.',
  },
} as const;

/** The namespaces Marathi carries. */
export const mr = { common: mrCommon, auth: mrAuth } as const;
